"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jspdf = _interopRequireDefault(require("jspdf"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

///////////////////////////////////////////////////////////////////////////////////////////
// pdf.js: Class for creating PDF Files                                                  //
///////////////////////////////////////////////////////////////////////////////////////////
// These are in mm
const PAGE_MARGIN_LEFT = 15;
const PAGE_MARGIN_RIGHT = 15;
const PAGE_MARGIN_TOP = 15;
const PAGE_MARGIN_BOTTOM = 15; // Font Sizes

const FONT_SIZE_H1 = 24;
const FONT_SIZE_H2 = 16;
const FONT_SIZE_NORMAL = 14;
const FONT_SIZE_SMALL = 12;
const PX_PER_MM = 3.77952755906;

class Pdf {
  constructor(fonts, orientation, units, papersize) {
    _defineProperty(this, "pdfDoc", null);

    _defineProperty(this, "boldFontName", null);

    _defineProperty(this, "normalFontName", null);

    _defineProperty(this, "italicFontName", null);

    let o = orientation ? orientation : 'l';
    let u = units ? units : 'mm';
    let s = papersize ? papersize : 'letter';
    this.pdfDoc = new _jspdf.default(o, u, s, true, true);
    this.addFonts(fonts);
    this.pdfDoc.deletePage(1); // Start PDF with no pages
  } ///////////////////////////////////////////////////////////////////////////////////////
  // This function adds the title page of your PDF File.                               //
  // Inputs:                                                                           //
  //   appName - Application Name (string)                                             //
  //   designDescription - Includes design name, description and date created (string) //
  //   coverImage - a structure containing the following properties:                   //
  //     > data image data base64 encoded (string)                                     //
  //     > format - Image format like PNG or JPEG (string)                             //
  ///////////////////////////////////////////////////////////////////////////////////////


  addTitlePage(appName, designDescription, coverImage) {
    // Add a Page
    this.pdfDoc.addPage(); // Get Page dimensions

    let width = this.pdfDoc.internal.pageSize.getWidth();
    let height = this.pdfDoc.internal.pageSize.getHeight(); // Set Image Dimensions (We will stretch to fill the page)

    let imageWidth = width - 16;
    let imageHeight = height - 16; // Draw Cover Image

    this.pdfDoc.addImage(coverImage.data, coverImage.format, 8, 8, imageWidth, imageHeight, undefined, 'MEDIUM');
    let xOffset = width * 32 / 50;
    let yOffset = height * 14 / 48; // Draw Application Name

    this.pdfDoc.setFont(this.normalFontName, 'normal').setFontSize(FONT_SIZE_H1).setTextColor('#48D1CC').text(appName, xOffset, yOffset, 'left');
    yOffset = height * 16 / 48; // Draw Box

    this.pdfDoc.setLineWidth(0.75);
    this.pdfDoc.rect(xOffset, yOffset, 85, 60);
    this.pdfDoc.setFont(this.normalFontName, 'normal').setFontSize(FONT_SIZE_SMALL).setTextColor('#000000');
    yOffset += this.pdfDoc.getTextDimensions('A').h * 1.5;
    xOffset += this.pdfDoc.getTextDimensions('A').w * 1.5; // Draw Text inside Box (Design Description, Design Owner, Created Date)

    let descriptionContents = this.pdfDoc.splitTextToSize(designDescription, 85 - this.pdfDoc.getTextDimensions('A').w * 3);

    for (let i = 0; i < descriptionContents.length; i++) {
      this.pdfDoc.text(descriptionContents[i], xOffset, yOffset, 'left');
      yOffset += this.pdfDoc.getTextDimensions('A').h;
    }

    return;
  } ///////////////////////////////////////////////////////////////////////////////////////
  // This function adds the data page to your PDF File.                                //
  // Inputs:                                                                           //
  //   heading - Page heading (string)                                                 //
  //   subheading - Page subheading (string)                                           //
  //   fieldData - a structure with the following properties:                          //
  //     > name (string)                                                               //
  //     > value (string)                                                              //
  ///////////////////////////////////////////////////////////////////////////////////////


  addDataPage(heading, subheading, fieldData) {
    // Add a Page
    this.pdfDoc.addPage(); // Get Page dimensions

    let width = this.pdfDoc.internal.pageSize.getWidth(); //let height = this.pdfDoc.internal.pageSize.getHeight();

    let yOffset = PAGE_MARGIN_TOP; // Draw Data Page Title, Top and Center

    this.pdfDoc.setFont(this.boldFontName, 'bold').setFontSize(FONT_SIZE_H1).text(heading, width / 2, yOffset, 'center');
    yOffset += this.pdfDoc.getTextDimensions(heading).h * 2; // Draw Data Page Subheading

    this.pdfDoc.setFont(this.boldFontName, 'bold').setFontSize(FONT_SIZE_H2).text(subheading, PAGE_MARGIN_LEFT, yOffset);
    yOffset += this.pdfDoc.getTextDimensions(subheading).h * 2; // Draw Data Fields

    this.pdfDoc.setFont(this.normalFontName, 'normal').setFontSize(FONT_SIZE_NORMAL);

    for (let fieldItem of fieldData) {
      let fieldtext = fieldItem.name + ': ' + fieldItem.value;
      this.pdfDoc.text(fieldtext, PAGE_MARGIN_LEFT, yOffset);
      yOffset += this.pdfDoc.getTextDimensions(fieldtext).h * 1.5;
    }

    return;
  } ///////////////////////////////////////////////////////////////////////////////////////
  // This function adds a page containing an image to your PDF File.                   //
  // Usually our graphs, stages and circuits are images.                               //
  // Inputs:                                                                           //
  //   imgData - a structure with the following properties:                            //
  //     > name - Page heading (string)                                                //
  //     > value - image data in Base64 format (string)                                //
  //     > format - image format like PNG, JPEG, GIF (string)                          //
  //     > width - image width in pixels (number)                                      //
  //     > height - image height in pixels (number)                                    //
  ///////////////////////////////////////////////////////////////////////////////////////


  addImagePage(imgData) {
    // Get image information
    let name = imgData.name;
    let data = imgData.value;
    let format = imgData.format;
    let imgWidth = imgData.width / PX_PER_MM;
    let imgHeight = imgData.height / PX_PER_MM; // Add a Page

    this.pdfDoc.addPage(); // Get Page dimensions

    let width = this.pdfDoc.internal.pageSize.getWidth();
    let height = this.pdfDoc.internal.pageSize.getHeight();
    let yOffset = PAGE_MARGIN_TOP; // Draw Image Title, Top and Center

    this.pdfDoc.setFont(this.boldFontName, 'bold').setFontSize(FONT_SIZE_H2).text(name, width / 2, yOffset, 'center');
    yOffset += this.pdfDoc.getTextDimensions(name).h; // Set Image Dimensions (Scaling is considered)

    let scaleWidth = (width - PAGE_MARGIN_LEFT - PAGE_MARGIN_RIGHT) / imgWidth;
    let scaleHeight = (height - yOffset - PAGE_MARGIN_BOTTOM) / imgHeight;
    let useScale = scaleWidth < scaleHeight ? scaleWidth : scaleHeight;
    let imageWidth = imgWidth * useScale;
    let imageHeight = imgHeight * useScale; // Draw Image information

    this.pdfDoc.addImage(data, format, PAGE_MARGIN_LEFT, yOffset, imageWidth, imageHeight, undefined, 'MEDIUM');
    return;
  } ///////////////////////////////////////////////////////////////////////////////////////
  // This function adds a page containing a table to your PDF File.                    //
  // Inputs:                                                                           //
  //   tableData - a structure with the following properties:                          //
  //     > title - Page heading (string)                                               //
  //     > columns - Table column names (array of string)                              //
  //     > columnWidths - List of table columns widths in                              //
  //                      percentage/100 (array of number)                             //
  //     > data - table rows (two dimensional array of strings)                        //
  ///////////////////////////////////////////////////////////////////////////////////////


  addTablePage(tableData) {
    this.pdfDoc.addPage(); // Get Page dimensions

    let width = this.pdfDoc.internal.pageSize.getWidth();
    let yOffset = PAGE_MARGIN_TOP;
    let xOffset = PAGE_MARGIN_LEFT; // Draw Data Page Title, Top and Center

    this.pdfDoc.setFont(this.boldFontName, 'bold').setFontSize(FONT_SIZE_H2).text(tableData.title, width / 2, yOffset, 'center');
    yOffset += this.pdfDoc.getTextDimensions(tableData.title).h * 2;
    let tableWidth = width - PAGE_MARGIN_LEFT - PAGE_MARGIN_RIGHT;
    let rowHeight = this.pdfDoc.getTextDimensions(tableData.title).h * 1.25; // Draw Data Table Headers

    this.pdfDoc.setFont(this.boldFontName, 'bold').setFontSize(FONT_SIZE_NORMAL);
    this.pdfDoc.setFillColor(0, 91, 149);
    this.pdfDoc.rect(xOffset, yOffset, tableWidth, rowHeight, 'FD');
    let tableStart = yOffset;
    let tableEnd = yOffset + rowHeight * (tableData.data.length + 1); // Draw Table Content

    yOffset += rowHeight;
    this.pdfDoc.rect(xOffset, yOffset, tableWidth, rowHeight * tableData.data.length); // Draw Row Lines

    for (let i = 0; i < tableData.data.length - 1; i++) {
      yOffset += rowHeight;
      this.pdfDoc.line(xOffset, yOffset, width - PAGE_MARGIN_RIGHT, yOffset);
    } // Draw Column Lines


    for (let i = 0; i < tableData.columns.length - 1; i++) {
      xOffset += tableWidth * tableData.columnWidths[i];
      this.pdfDoc.line(xOffset, tableStart, xOffset, tableEnd);
    } // Draw Header Text


    this.pdfDoc.setTextColor(255);
    xOffset = PAGE_MARGIN_LEFT + 1;
    yOffset = tableStart;

    for (let i = 0; i < tableData.columns.length; i++) {
      this.pdfDoc.text(tableData.columns[i], xOffset, yOffset + this.pdfDoc.getTextDimensions(tableData.columns[i]).h + 0.5, 'left');
      xOffset += tableWidth * tableData.columnWidths[i];
    } // Draw Row Data


    this.pdfDoc.setFont(this.normalFontName, 'normal').setFontSize(FONT_SIZE_NORMAL);
    this.pdfDoc.setTextColor(0);
    yOffset = tableStart;

    for (let i = 0; i < tableData.data.length; i++) {
      xOffset = PAGE_MARGIN_LEFT + 1;
      yOffset += rowHeight;
      let rowData = tableData.data[i];

      for (let j = 0; j < rowData.length; j++) {
        this.pdfDoc.text(rowData[j], xOffset, yOffset + this.pdfDoc.getTextDimensions(rowData[j]).h + 0.5, 'left');
        xOffset += tableWidth * tableData.columnWidths[j];
      }
    }

    return;
  } ///////////////////////////////////////////////////////////////////////////////////////
  // This function returns your PDF Document Object in Blob form.                      //
  // Returns:                                                                          //
  //   Blob object containing your PDF document (Blob)                                 //
  ///////////////////////////////////////////////////////////////////////////////////////


  toBlob() {
    return this.pdfDoc.output('blob');
  } ///////////////////////////////////////////////////////////////////////////////////////
  // This function saves your PDF to a file on storage.                                //
  // Inputs:                                                                           //
  //   fileName - Name of PDF file, including path (string)                            //
  ///////////////////////////////////////////////////////////////////////////////////////


  toFile(fileName) {
    this.pdfDoc.save(fileName);
    return;
  } ///////////////////////////////////////////////////////////////////////////////////////
  // This function deletes all pages of your PDF Document.                             //
  ///////////////////////////////////////////////////////////////////////////////////////


  clear() {
    let numPages = this.pdfDoc.internal.getNumberOfPages();

    for (let i = 0; i < numPages; i++) {
      this.pdfDoc.deletePage(1); // Delete PDF PAge
    }

    return;
  } // Internal function called inside constructor to add custom/external fonts


  addFonts(fonts) {
    let normalFontIndex = 0;

    if (fonts) {
      for (let i = 0; i < fonts.length; i++) {
        this.pdfDoc.addFileToVFS(fonts[i].fileName, fonts[i].data);
        this.pdfDoc.addFont(fonts[i].fileName, fonts[i].fontName, fonts[i].fontStyle);

        switch (fonts[i].fontStyle) {
          case 'normal':
            this.normalFontName = fonts[i].fontName;
            normalFontIndex = i;
            break;

          case 'bold':
            this.boldFontName = fonts[i].fontName;
            break;

          case 'italic':
            this.italicFontName = fonts[i].fontName;
            break;
        }
      }
    }

    if (!this.normalFontName) this.normalFontName = 'helvetica';

    if (!this.boldFontName) {
      this.boldFontName = this.normalFontName;
      if (this.normalFontName !== 'helvetica') this.pdfDoc.addFont(fonts[normalFontIndex].fileName, fonts[normalFontIndex].fontName, 'bold');
    }

    if (!this.italicFontName) {
      this.italicFontName = this.normalFontName;
      if (this.normalFontName !== 'helvetica') this.pdfDoc.addFont(fonts[normalFontIndex].fileName, fonts[normalFontIndex].fontName, 'italic');
    }
  }

}

exports.default = Pdf;